import { render, staticRenderFns } from "./CoopFarmTickets.vue?vue&type=template&id=96f2a0c2&"
import script from "./CoopFarmTickets.vue?vue&type=script&lang=ts&"
export * from "./CoopFarmTickets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemTitle})
